import React from "react";

const PageNotAccessible = () => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img
          src="/images/ambit-logo.png" // Replace with the logo URL
          alt="Ambit Logo"
          className="h-10"
        />
      </div>
      <div style={styles.content}>
        <h2 style={styles.errorTitle}>Page not Accessible!</h2>
        <p style={styles.errorMessage}>
          Your current user role doesn’t grant permission to access this page.
        </p>
        <button style={styles.button} onClick={() => (window.location.href = "/")}>
          BACK TO HOME
        </button>
        <div style={styles.imageContainer}>
          <img
            src="/images/no_file.png" // Replace with the error image URL
            alt="Error illustration"
            style={styles.errorImage}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "100vw",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    padding: "20px",
    alignItems: 'center',
    backgroundColor: "#fff",
  },
  header: {
    marginBottom: "20px",
    width: '100%',
  },
  logo: {
    width: "220px",
    height: "65px",
  },
  title: {
    margin: "0",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  },
  tagline: {
    margin: "0",
    fontSize: "14px",
    color: "#666",
  },
  content: { 
    padding: "30px",
    borderRadius: "10px",
    textAlign: "center",
    alignItems: "center",
    width: "100%",
  },
  errorTitle: {
    fontSize: "22px",
    color: "#ED1C24",
    fontWeight: "bold",
    margin: "10px 0",
  },
  errorMessage: {
    fontSize: "16px",
    color: "#231F20",
    margin: "10px 0",
  },
  button: {
    color: "#ED1C24",
    border: "1px solid #ED1C24",
    padding: "10px 20px",
    borderRadius: "10px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
  },
  buttonHover: {
    backgroundColor: "#c0392b",
  },
  imageContainer: {
    marginTop: "70px",
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    width: '100%'
  },
  errorImage: {
    width: "300px",
    height: "300px",
  },
};

export default PageNotAccessible;
